module.exports = __webpack_public_path__ + "img/search-engine.c337b853.svg";